import { render } from "./PropsProd.vue?vue&type=template&id=63a1cf89&scoped=true"
import script from "./PropsProd.vue?vue&type=script&lang=js"
export * from "./PropsProd.vue?vue&type=script&lang=js"

import "./PropsProd.vue?vue&type=style&index=0&id=63a1cf89&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a1cf89"]])

export default __exports__